export default __webpack_public_path__ + "static/Daniel_Koch_Portrait_2017_415x258-752ffe64a39f6a2467690d0e30365fec.jpg";